import React from 'react'
import type { ReactElement } from 'react';

import { render } from '@testing-library/react'

import { muiTheme, ThemeProvider } from '@acre/design-system'

export default (tree: ReactElement) => {
  return render(<ThemeProvider theme={muiTheme}>{tree}</ThemeProvider>)
}
